import ScrollToTarget from '../../utilities/js/scroll-to.js';

class ScrollLot {
    constructor (elements) {
        this.$elements = elements;

        this.scrollTo = new ScrollToTarget();
        this.waiting = false;
    }

    initialize () {
        this.setEvents();
    }

    setEvents () {
        for (let index = 0; index < this.$elements.length; index++) {
            this.$elements[index].addEventListener('click', (e) => {
                e.preventDefault();
                this.scrollTo.scrollTo(document.querySelector(this.$elements[index].getAttribute('data-scroll-to-lot')), 500, 'easeOutQuad', -120);
            });
        }
    }
}

export { ScrollLot };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    const $lot = $context.querySelectorAll('[data-scroll-to-lot]');

    if ($lot) {
        const scroll = new ScrollLot($lot);
        scroll.initialize();
    }
});
